import styled from 'styled-components';

export const Container = styled.div`
    padding: 80px 60px;
    background-color: radial-gradient(circle, rgba(92, 39, 251, 1) 0%, rgba(0, 0, 0, 1) 100%);
  `;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 1200px;
    margin: 0 auto;
`;

export const Column = styled.div`
    display: flex;
    flex-direction: column;
    text-align: left;
    margin-left: 60px;
`;

export const Row = styled.div``;
export const Link = styled.div``;
export const Title = styled.div``;